export default "__VITE_ASSET__Dv83IfYo__"